/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSelectContour12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectContour12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M8.714 4.964a.656.656 0 0 0-.928-.928l-2.161 2.16-1.036-1.035a.656.656 0 0 0-.928.928l1.5 1.5a.656.656 0 0 0 .928 0l2.625-2.625Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6Zm6 4.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectContour16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectContour16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M11.619 6.619A.875.875 0 0 0 10.38 5.38L7.5 8.263 6.119 6.88A.875.875 0 1 0 4.88 8.12l2 2a.875.875 0 0 0 1.238 0l3.5-3.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8 6A6 6 0 1 1 8 2a6 6 0 0 1 0 12Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectContour20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectContour20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm4.66-11.749a1 1 0 0 0-1.41.094l-4.517 5.158-1.996-2.178a1 1 0 1 0-1.474 1.35l2.373 2.59a1.5 1.5 0 0 0 2.119.094l.06-.058.055-.06 4.884-5.579a1 1 0 0 0-.093-1.41Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectContour24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectContour24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm4.66-11.749a1 1 0 0 0-1.41.094l-4.517 5.158-1.996-2.178a1 1 0 0 0-1.474 1.35l2.373 2.59a1.5 1.5 0 0 0 2.119.094l.06-.058.055-.06 4.884-5.579a1 1 0 0 0-.093-1.41Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSelectContour = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectContour(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconSelectContour12 {...iconProps} />;
        case '16':
            return <IconSelectContour16 {...iconProps} />;
        case '20':
            return <IconSelectContour20 {...iconProps} />;
        case '24':
            return <IconSelectContour24 {...iconProps} />;
        default:
            return <IconSelectContour24 {...iconProps} />;
    }
});
